



















import { Phone } from '@/types/Person.interface'
import Vue from 'vue'
import { mapGetters } from 'vuex'
export default Vue.extend({
    props: ['phones'],
    data() {
        return {
            clones: null,
            edited: false,
            loading: false,
            models: [],
            selectedDefault: null
        }
    },
    computed: {
        ...mapGetters(['smsAccount'])
    },
    mounted() {
        //  Clone the phones prop (so we can discard changes if needed)
        this.clones = window._.cloneDeep(this.phones)

        //  Create a v-model for each phone (for validation purposes)
        this.phones.forEach((x) => {
            let phone = this.$options.filters.phoneTrim(x.free_form_number)
            this.models.push(phone)
        })

        //  Set the selected radio to the default phone
        this.selectedDefault = this.phones.find((x) => x.default == true)
    },
    methods: {
        async onDefaultChanged(phone: Phone): Promise<void> {
            //  Set the phone to default
            phone.default = true

            //  Find all the phones that are NOT the selected phone
            const notDefaults = this.phones.filter((x) => x.id !== phone.id)

            //  Set all the 'notDefaults' to default = false
            notDefaults.forEach((x) => {
                x.default = false
            })

            //  Find the clone that matches our selected phone
            const currClone = this.clones.find((x) => x.id === phone.id)

            //  Set the clone to default in case we update a number too
            currClone.default = true

            //  Find all of our clones that AREN'T the selected phone
            const notDefaultsClone = this.clones.filter((x) => x.id !== phone.id)

            //  Make the rest of the clones have default = false so that they don't affect our num update
            notDefaultsClone.forEach((x) => {
                x.default = false
            })

            //  Update the default immediately
            const response = await this.$store.dispatch('phoneNumbersPut', phone)

            //  If the request failed, do nothing
            if (!response) return

            //  Else, notify the user of the sucessful change
            this.$store.commit('appNotificationBarSet', {
                message: 'Phone number updated successfully',
                type: 'success'
            })
        },
        setObjectValue(value: string, idx: number): void {
            //  Get the original value
            const original = this.phones[idx].free_form_number

            //  If the current value is NOT the original value, set edited to true
            if (original != value) this.edited = true

            //  Update the field on the correct cloned phone
            this.clones[idx].free_form_number = value
        },
        submit(): void {
            //  If NO changes were maid, close the form
            if (!this.edited) return this.$store.dispatch('dialogClose', 'APP')

            //  Start the loading spinner
            this.loading = true

            //  Else, submit the changes to the parent
            this.$emit('submit', this.clones)

            //  Stop the loading spinner
            this.loading = false
        }
    }
})
